import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ADDRESS_MODAL_STYLE } from "../../../constants";

@Component({
	selector: 'app-danger-zone',
	templateUrl: './danger-zone.component.html',
	styleUrls: ['./danger-zone.component.scss']
})

export class DangerZoneComponent implements OnInit {

	selectedValue = 'Jon Doe (>email<) - UserId';
	listOfOptions: Array<string> = ['Jon Doe (>email<) - UserId', 'user 2', 'user 3', 'user 4'];
	organizationName: string = "Orga AB";

	changeOwnerModalVisible: boolean = false;

	deleteOrganizationForm: FormGroup;
	deleteModalVisible: boolean = false;
	deleteModalTitle: string;
	formModalStyle: object = ADDRESS_MODAL_STYLE;

	constructor(
		private formBuilder: FormBuilder
	) { }

	ngOnInit(): void {
		this.deleteOrganizationForm = this.formBuilder.group({
			organizationName: ['', [Validators.required]]
		});

		this.deleteOrganizationForm.valueChanges.subscribe((value) => {
			if (value.organizationName !== this.organizationName) {
				this.deleteOrganizationForm.controls['organizationName'].setErrors({ 'invalidOrganization': true });
			}
		});
	}

	/**
	 * Handle delete submission
	 */
	handleDelete(formValues: object): void {

	}

	/**
	 * Handle delete form close
	 */
	handleDeleteCancel(): void {
		this.deleteModalVisible = false;
		this.deleteOrganizationForm.reset();
	}

	/**
	 * Display delete Organization Modal
	 */
	showDeleteModal(): void {
		this.deleteModalVisible = true;
	}

	/**
	 * Display change Organization owner Modal
	 */
	showChangeOwnerModal(): void {
		this.changeOwnerModalVisible = true;
	}

	/**
	 * Handle change owner Modal close
	 */
	handleChangeOwnerCancel(): void {
		this.changeOwnerModalVisible = false;
		this.selectedValue = '';
	}

	/**
	 * Handel change owner OK
	 */
	handleChangeOwnerOk(): void {

	}


}
